import type { Metafield, UserError } from "@shopify/hydrogen-react/storefront-api-types";

const STORE_NAME = import.meta.env.VITE_REACT_APP_NAME as string;

interface IRestockNotification {
  data: {
    metafieldsSet: {
      metafields: Metafield[];
      userErrors: UserError;
    };
  };
}

export const restockNotification = async ({
  domain,
  variantId,
  value,
}: {
  domain: string;
  value: string;
  variantId: string;
}) => {
  try {
    const url = "https://77zx4jqmqcybx5r5rwbcmtnlzq0pwmnw.lambda-url.ap-northeast-2.on.aws/";
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify({ store: STORE_NAME, domain, value, variantId }),
    }).then((res) => res);
    if (response.status === 200) {
      return (await response.json()) as IRestockNotification;
    }
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new Error(message);
  }
};
